<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-12 18:06:52
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:26:05
 * @Description: file content
 添加微信美女AI客户小原 http://assets.wxmp.ruthus.com/henduoke/share_moments/icon1.png
 获取美女机器人小原个人二维码 http://assets.wxmp.ruthus.com/henduoke/share_moments/icon2.png
 -->
<template>
  <div>
    <!-- 专属分享 -->
    <div class="masks" v-if="isLoadComplete">
      <div class="popup-layers animated zoomIn">
        <div class="popups">
          <div class="pop-titles">{{name+'专享'}}</div>
          <div class="pop-content">
            <div class="word">{{word}}</div>
            <div v-if="interest&&interest.wxsmallpic&&interest.title" class="interest">
              <div class="interest_title">您可能还感兴趣：</div>
              <div class="interest_hr"></div>
              <div class="interest_content" @click="clickInterest">
                <div class="interest_content_img">
                  <img :src="interest.wxsmallpic" alt />
                </div>
                <div class="interest_content_word">{{interest.title || ''}}</div>
              </div>
            </div>
          </div>
          <div class="pop-btns">
            <div v-if="leftBtn.isShow" class="btn" @click="clickBtn(leftBtn)">{{leftBtn.txt}}</div>
            <div v-if="leftBtn.isShow&&rightBtn.isShow" class="line"></div>
            <div v-if="rightBtn.isShow" class="btn" @click="clickBtn(rightBtn)">{{rightBtn.txt}}</div>
          </div>
        </div>
        <div class="closes" @click="clickClose"></div>
      </div>
    </div>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="closeShowImg2"></ShowImg2>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import request from "@/utils/request";
import Cookies from "js-cookie";
import global_ from "@/global.config";
import { mapState, mapMutations } from "vuex";
const ShowImg2 = () => import("@/components/showimg2.vue");

export default {
  components: {
    ShowImg2
  },
  props: {},
  data() {
    return {
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isLoadComplete: false, //加载数据是否完成
      name: "",
      word: "",
      // interest
      // {
      //   img:
      //     "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1561598196000-97.png",
      //   word: "成都房地产，不是数学方程式能说明白的！"
      // }
      interest: null,
      leftBtn: {
        isShow: false,
        txt: "",
        type: ""
      },
      rightBtn: {
        isShow: false,
        txt: "",
        type: ""
      },

      // 枚举按钮类型
      enumType: {
        share: "share", //分享
        subscribe: "subscribe", //关注
        draw: "draw", //抽奖
        chat: "chat", //聊天
        addrobotwx_web: "addrobotwx_web",
        addrobotwx_xcx: "addrobotwx_xcx",
        hdbqrcode_xcx: "hdbqrcode_xcx",
        hdbqrcode_web: "hdbqrcode_web",
        hdkqrcode_web: "hdkqrcode_web",
        register_xcx: "register_xcx"
      },
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    closeShowImg2() {
      this.showImg2.isShow = false;
    },
    // 点击感兴趣
    clickInterest() {
      if (this.interest && this.interest.id && this.interest.psn) {
        util.openFound(this, this.interest);
      }
    },
    // 关闭
    clickClose() {
      this.$emit("close");
    },
    clickBtn(btn) {
      const that = this;

      if (btn.type == that.enumType.addrobotwx_web) {
        // 机器人-网页
        that.showImg2 = {
          isShow: true,
          url: "https://assets.wxmp.ruthus.com/henduoke/xiaoyuanwxqrcode.jpeg",
          width: "50%",
          intro: "扫码添加美女Ai客服小原！"
        };
      } else if (btn.type == that.enumType.addrobotwx_xcx) {
        util.navigateToShareMomentsPage(null, {
          sendMessageTitle: "获取小原微信二维码",
          sendMessageImg:
            "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon8.png",
          sendMessagePath: "/pages/hdk/intro/intro?action=qr_wxrobot"
        });
      } else if (btn.type == that.enumType.hdbqrcode_xcx) {
        // 很多宝-小程序
        util.navigateToShareMomentsPageReturnImg(
          this,
          {
            // title: "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            // desc: "24位您的朋友已经关注了",
            // img:
            //   "https://assets.rurushishi.com/yq-rs-make/other/henduobao_icon.png",
            sendMessageTitle:
              "关注很多宝公众号，天天都有高净值精彩内容免费更新",
            sendMessageImg:
              "http://assets.wxmp.ruthus.com/henduoke/share_moments/icon6.png",
            // intro: "关注很多宝公众号，天天都有高净值精彩内容免费更新"
            action:'qr_subscribe_gzh_hdb'
          }
        );
      } else if (btn.type == that.enumType.hdbqrcode_web) {
        // 很多宝-网页
        that.showImg2 = {
          url:
            "https://assets.rurushishi.com/yq-rs-make/other/henduobao_code.jpg",
          width: "50%",
          intro: "扫码关注，为您汇聚高净值精彩内容！",
          isShow: true
        };
      } else if (btn.type == that.enumType.hdkqrcode_web) {
        // 很多客-网页
        if (that.userInfo.user && that.userInfo.user.appid) {
          comreq
            .limitWxQRCodeWithCallbackUrl(that.userInfo.user.appid, "")
            .then(function(data) {
              that.showImg2 = {
                isShow: true,
                url: data,
                width: "50%",
                intro: "扫码关注，免费获取AI获客神器！"
              };
            });
        } else {
          that.showImg2 = {
            url:
              "https://assets.rurushishi.com/yq-rs-make/other/henduoke_code.jpg",
            width: "50%",
            intro: "扫码关注，免费获取AI获客神器！",
            isShow: true
          };
        }
      } else if (btn.type == that.enumType.register_xcx) {
        // 注册很多客-小程序
        wx.miniProgram.navigateTo({
          url: `/pages/hdk/register/register`
        });
      }
    },
    setConfig() {
      const that = this;

      return new Promise(function(resolve, reject) {
        that.name =
          (that.hdkUserInfo && that.hdkUserInfo.Ui.Name) ||
          (that.userInfo.user && that.userInfo.user.nickname) ||
          "您的";
        /**
很多客微信号关注了，已注册
提示文字：有激励：您已经赚到*元，到很多客小程序“我的账户”领取。
没激励：予人玫瑰手有余香
按钮：我要获客（很多客小程序二维码），更多精彩（很多宝服务号二维码）
小程序形式：
很多客微信号关注了，已注册
提示文字：您已经赚到*元，点击这里领取。
没激励：予人玫瑰手有余香
按钮：添加美女AI（聊天方式引导加小原好友）
       */
        if (
          that.userInfo.user &&
          that.userInfo.user.state == 1 &&
          that.hdkUserInfo.isRegister
        ) {
          if (that.isInMiniProgram) {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "添加美女AI";
            that.leftBtn.type = that.enumType.addrobotwx_xcx;
            that.leftBtn.isShow = true;
          } else {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "我要获客";
            that.leftBtn.type = that.enumType.hdkqrcode_web;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          }
        } else if (
          /**
         * 很多客微信号没关注，已注册
提示文字：您已经赚到*元，到很多客小程序“我的账户”领取。
没激励：予人玫瑰手有余香
按钮：我要获客（很多客公众号二维码），更多精彩（很多宝服务号二维码）
小程序形式：
第一：您已经赚到*元，点击这里领取。
没激励：予人玫瑰手有余香
按钮：更多精彩（聊天方式引导加很多客微信号）
         */
          !(that.userInfo.user && that.userInfo.user.state == 1) &&
          that.hdkUserInfo.isRegister
        ) {
          if (that.isInMiniProgram) {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_xcx;
            that.rightBtn.isShow = true;
          } else {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "我要获客";
            that.leftBtn.type = that.enumType.hdkqrcode_web;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          }
        } else if (
          !(that.userInfo.user && that.userInfo.user.state == 1) &&
          !(that.hdkUserInfo && that.hdkUserInfo.isRegister)
        ) {
          /**
         * 很多客微信号没关注，没注册（不一定是专业人士）
提示文字：您已经赚到*元，已经发送到您的微信零钱，请多多分享。没激励：予人玫瑰手有余香
按钮：我要获客（很多客公众号二维码），更多精彩（很多宝服务号二维码）
         */
          if (that.isInMiniProgram) {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "补充信息";
            that.leftBtn.type = that.enumType.register_xcx;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          } else {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "我要获客";
            that.leftBtn.type = that.enumType.hdkqrcode_web;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          }
        } else if (
          that.userInfo.user &&
          that.userInfo.user.state == 1 &&
          !(that.hdkUserInfo && that.hdkUserInfo.isRegister)
        ) {
          /**
      很多客微信号已关注，没注册（不一定是专业人士）
提示文字：您已经赚到*元，已经发送到您的微信零钱，请多多分享。
没激励：予人玫瑰手有余香
按钮：我要获客（很多客小程序二维码），更多精彩（很多宝服务号二维码）
         */
          if (that.isInMiniProgram) {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "补充信息";
            that.leftBtn.type = that.enumType.register_xcx;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          } else {
            that.word = "您已经进入积极推广抽奖，稍后请注意微信零钱通知。";
            that.leftBtn.txt = "我要获客";
            that.leftBtn.type = that.enumType.hdkqrcode_web;
            that.leftBtn.isShow = true;
            that.rightBtn.txt = "更多精彩";
            that.rightBtn.type = that.enumType.hdbqrcode_web;
            that.rightBtn.isShow = true;
          }
        }

        resolve();
      });
    }
  },
  created() {},
  mounted() {
    let that = this;
    util
      .checkMapStateCallback(that, ["userInfo", "hdkUserInfo", "pageInfo"])
      .then(() => {
        Promise.all([
          comreq.sharePageInfo(that.pageInfo.PageId),
          comreq.listPageInfoWithChannel(that, 1, 0, 2)
        ]).then(function(res) {
          let sharePageInfo = res[0],
            listPageInfo = null;
          if (util.isArray(res[1].list)) {
            listPageInfo = res[1].list;
          }
          that.setConfig().then(() => {
            if (sharePageInfo && sharePageInfo.sharePageTitle) {
              that.word = sharePageInfo.sharePageTitle;
            }
            if (listPageInfo) {
              if (listPageInfo.length == 2) {
                if (that.pageInfo.PageId != listPageInfo[0].id) {
                  that.interest = listPageInfo[0];
                } else if (that.pageInfo.PageId != listPageInfo[1].id) {
                  that.interest = listPageInfo[1];
                }
              } else if (listPageInfo.length == 1) {
                if (that.pageInfo.PageId != listPageInfo[0].id) {
                  that.interest = listPageInfo[0];
                }
              }
            }
            that.isLoadComplete = true;
          });
        });
      });
  }
};
</script>
<style lang="stylus" scoped>
// 专属
.masks {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 35;
}

.popup-layers {
  position: absolute;
  left: 50px;
  right: 50px;
  top: 25%;
  background: transparent;
}

.popup-layers .popups {
  width: 100%;
  background-color: #ffffff;
  position: relative;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.popups .pop-titles {
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  font-weight: 600;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/share-after-action/pop-titles_bg.png');
  background-size: 100% 100%;
  position: absolute;
  min-width: 50%;
  padding: 0 20px;
  top: -5px;
}

.popups .pop-content {
  margin-top: 45px;
  margin-bottom: 25px;
  width: 90%;
  background: rgba(250, 250, 250, 1);
  box-shadow: 0px 3px 7px 0px rgba(139, 64, 64, 0.78);
  border-radius: 5px;
}

.popups .pop-content .word {
  padding: 20px;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: justify;
}

.popups .pop-content .interest_title {
  margin: 20px;
  margin-bottom: 0px;
}

.popups .pop-content .interest_hr {
  margin: 20px;
  margin-top: 10px;
  margin-bottom: 0px;
  height: 1px;
  background: rgba(234, 234, 234, 1);
}

.popups .pop-content .interest_content {
  margin: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
}

.popups .pop-content .interest_content_img {
  width: 50px;
}

.popups .pop-content .interest_content_img>img {
  width: 50px;
  height: 50px;
}

.popups .pop-content .interest_content_word {
  font-size: 12px;
  line-height: 18px;
  color: rgba(51, 51, 51, 1);
  padding-left: 10px;
  text-align: justify;
  flex: 1;
}

.popups .pop-btns {
  width: 100%;
  display: flex;
  background-color: #F97172;
  color: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.popups .pop-btns .btn {
  flex: 1;
  text-align: center;
  height: 35px;
  line-height: 35px;
}

.popups .pop-btns .line {
  width: 1px;
  height: 35px;
  background: rgba(255, 255, 255, 1);
}

.closes {
  width: 0.88rem;
  height: 0.88rem;
  background: url('https://assets.rurushishi.com/yq-rs-make/components/mask/new-close.png') no-repeat center center; // assets.rurushishi.com/yq-rs-make/components/mask/new-close.png) no-repeat center center;
  background-size: 0.64rem 0.64rem;
  z-index: 35;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>


